import React, { useEffect, useState, useRef } from 'react';

export default function MobileCardOverflow({
  loading,
  cards,
  buildCards,
  loadingCardsMemo,
  fetchMore,
  updateQuery,
  page,
  setPage,
}) {
  const sliderRef = useRef(null);

  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    setIsFetching(loading);
  }, [loading]);

  useEffect(() => {
    const sliderCurrent = sliderRef.current;

    const handleScroll = () => {
      if (
        sliderCurrent.scrollLeft >=
          sliderCurrent.lastElementChild.getBoundingClientRect().left &&
        !isFetching
      ) {
        setIsFetching(true);
        fetchMore({
          variables: { page: String(page + 1) },
          updateQuery,
        });
        setPage(page + 1);
      }
    };

    sliderCurrent.addEventListener('scroll', handleScroll);

    return () => sliderCurrent.removeEventListener('scroll', handleScroll);
  }, [fetchMore, isFetching, updateQuery, sliderRef, page, setPage]);

  return (
    <div className="card-slider-overflow" ref={sliderRef}>
      {!cards.length ? loadingCardsMemo : cards.map(buildCards)}
      <span className="end-slider-padding" />
      {/* <LoadingCard card_type={card_type} /> */}
    </div>
  );
}
